import { useState } from "react";
import api from "@src/../js/api";
import helpers from "@src/../js/helpers";

export const useStoreLocalization = (endpoint) => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [enabledCurrencies, setEnabledCurrencies] = useState([]);

  const fetchCountries = async () => {
    setIsLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const country = helpers.getCookie('localization');
      const query = `query @inContext(country: ${country}) {
        localization {
          availableCountries {
            currency {
              isoCode
              name
              symbol
            }
            isoCode
            name
            unitSystem
          }
          country {
            currency {
              isoCode
              name
              symbol
            }
            isoCode
            name
            unitSystem
          }
        }
      }
      `;

      let headers = {
          "Content-Type": "application/graphql",
          "X-Shopify-Storefront-Access-Token": `${api.getStorefrontToken()}`,
      };

      const response = await fetch(
          `${helpers.getDomain()}/api/2024-07/graphql.json`,
          {
              method: "POST",
              headers: headers,
              body: query,
          },
      );


      const jsonResponse = await response.json();
      let currencies = [];

      if (jsonResponse.data.localization) {
          for (let country of jsonResponse.data.localization.availableCountries) {
            currencies.push({
                name: country.currency.name,
                code: country.isoCode,
                symbol: country.currency.symbol,
                country: country.name,
            });
          }
          setEnabledCurrencies(currencies);
      }

      if (response.ok) {
        setSuccess(true);
        setError(null);
      } else {
        setSuccess(false);
        setError("Failed to subscribe. Please try again.");
      }
    } catch (error) {
      setError("An error occurred. Please try again later.");
      setSuccess(false);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    success,
    enabledCurrencies,
    fetchCountries,
  };
};
